module.exports = __webpack_public_path__ + "img/s-hd.87d0bfcf.webp";